// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Es6Promise from 'es6-promise'
import App from './App'
import router from './router'
import Axios from 'axios'
import wx from 'weixin-js-sdk'
import api from './api/index.js'
import axiosTripartite from './api/axiosTripartite.js'

import base from '@/common/js/base.js'; //全局函数
Object.keys(base).forEach(item => {
  //将base里面得方法,全部挂载到vue上面,使得在其他地方,就可以用this去获取了
  Vue.prototype[item] = base[item];
});

import "@/vant"
// 导入 自定义
import "@/vant/icont.css";
import "@/vant/shop.css";
import { Dialog } from 'vant';

// 全局注册
Vue.use(Dialog);
import 'amfe-flexible'
// var Less = require('Less');
require('es6-promise').polyfill()
Es6Promise.polyfill()
Vue.config.productionTip = false
import { Lazyload } from 'vant';
Vue.use(Lazyload, {
  lazyComponent: true
});

//复制到粘贴板插件
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Axios.defaults.headers.post['Content-Type'] = 'Access-Control-Allow-Headers';

Vue.prototype.$axios = Axios
Vue.prototype.$wx = wx

Vue.prototype.$api = api
Vue.prototype.$axiosTripartite = axiosTripartite

import Vuex from 'vuex';

Vue.use(Vuex);
var store = new Vuex.Store({
  //存储状态
  state: {
    sales: null,
    hulianwang: null,
    isOrderStatus: 0,
    setmealObj: null,
    userinfo: null,
    setmeal: [
      {
        name: "商超消费权益10元包",
        key: "M1XJLueZlJfLZiOqHYrrGLRlx1W0gBSL",
        money: "10",
        code: 910326994,
        type: 1,
        bg: "linear-gradient(#30B7E8, #48DDC2)"
      },
      {
        name: "商超消费权益15元包",
        key: "tFZ3Tk9ohh9NRjGN5KGud2gudxGskuGo",
        money: "15",
        code: 910326995,
        type: 2,
        bg: "linear-gradient(#E94545, #F25B2B)"
      },
      {
        name: "商超消费权益30元包",
        key: "SWfn28ZMqFrNzRSVcDVECgDj5y67Jq1r",
        money: "30",
        code: 910326996,
        type: 3,
        bg: "linear-gradient(#F64547, #EB4462)"
      },
      {
        name: "商超随心权益包",
        key: "eumyo8gDEmk3Y2DtEFZuzSVE9oU557dT",
        money: "10",
        code: 910326997,
        type: 4,
        bg: "linear-gradient(#fc652a, #fd7e2e, #fd5e38)"
      },
    ],
  },
  //显示的更改state
  mutation: {

  },
  //过滤state中的数据
  getters: {},
  //异步操作
  actions: {

  }
});
Vue.prototype.$store = store
export default store

//在页面加载时读取sessionStorage里的状态信息
if (sessionStorage.getItem("store")) {
  store.replaceState(
    Object.assign(
      {},
      store.state,
      JSON.parse(sessionStorage.getItem("store"))
    )
  );
}

//在页面刷新时将vuex里的信息保存到sessionStorage里
window.addEventListener("beforeunload", () => {
  sessionStorage.setItem("store", JSON.stringify(store.state));
});

window.addEventListener('pagehide', () => {
  sessionStorage.setItem('store', JSON.stringify(store.state))
})




// WEBPACK FOOTER //
// ./src/main.js